import Swal from 'sweetalert2';

/**
 * Единый текст модалки «не хватает обязательных документов» для всего JHA-флоу
 * (initial submit на шаге Documents и финальный submit на Review).
 *
 * Объясняет юзеру ДВЕ вещи:
 *   • ПОЧЕМУ документ требуется — reason каждого пункта (какой именно
 *     Work Activity / Energy / Hazard сработал; приходит из describeMatch).
 *   • ЧТО СДЕЛАТЬ — приложить фото готового бланка ИЛИ заполнить форму в
 *     приложении (ровно те две кнопки, что есть в списке документов).
 *
 * Работает офлайн: текст строится из локального оценщика триггеров (IDB),
 * сетевой ответ не нужен. На бэкенд-422 используется тот же формат `missing`
 * ({ document_name, document_key, reason }), поэтому модалка идентична.
 */
const raiseSwalZ = () => {
    document.querySelectorAll('.swal2-container').forEach((c) => { c.style.zIndex = '13000'; });
};

export function buildMissingDocsHtml(missing) {
    const items = (missing || []).map((m) => {
        const safeName = (m.document_name || m.name || '').replace(/</g, '&lt;');
        // reason показываем как есть: фронтовый оценщик отдаёт "Triggered by — <...>",
        // а бэкенд-422 — самодостаточное предложение ("Required document ... is missing
        // ... (triggered by condition #N)."). Оба варианта читаются нормально без
        // дополнительного префикса.
        const safeReason = (m.reason || '').replace(/</g, '&lt;');
        return `<li style="margin-bottom: 10px;"><strong>${safeName}</strong>` +
            (safeReason ? `<div style="font-size: 12px; color: #6b7280; margin-top: 2px;">${safeReason}</div>` : '') +
            `</li>`;
    }).join('');
    return `<div style="text-align: left;">` +
        `<p style="margin: 0 0 10px;">The Work Activities, Energy Sources or Hazards you selected made the document(s) below ` +
        `<strong>Required</strong>. The JHA can't be sent until each one is provided.</p>` +
        `<p style="margin: 0 0 6px;"><strong>For each document below, do one of these:</strong></p>` +
        `<ul style="padding-left: 20px; margin: 0 0 12px;">` +
        `<li style="margin-bottom: 4px;">📷 Tap <strong>Photo</strong> to attach a picture of the completed paper form, or</li>` +
        `<li>📝 Tap <strong>Fill Form</strong> to complete it digitally in the app.</li>` +
        `</ul>` +
        `<p style="margin: 0 0 6px;"><strong>Still missing:</strong></p>` +
        `<ul style="padding-left: 20px; margin: 0;">${items}</ul></div>`;
}

export function showMissingDocsDialog(missing) {
    return Swal.fire({
        icon: 'warning',
        title: 'Required documents are missing',
        html: buildMissingDocsHtml(missing),
        confirmButtonText: 'OK',
        confirmButtonColor: '#f59e0b',
        didOpen: raiseSwalZ,
    });
}
